import { useEffect } from "react";
import { useLoaderData } from "react-router";

import { Error404 } from "../pages/Error404";
import { useCategoriesStore } from "../stores/CategoriesStore";
import { useProductStore } from "../stores/ProductStore";
import { Category } from "./Category";
import { ProductPage } from "./ProductPage";
import { Static } from "./Static";

export const UrlHandler = () => {
	const url = useLoaderData();

	useEffect(() => {
		if (url?.prefetchedProduct?.id) {
			useProductStore.setState({ info: url.prefetchedProduct });
		}
	}, [url?.prefetchedProduct]);

	useEffect(() => {
		if (url?.prefetchedCategory?.content_id) {
			useCategoriesStore.setState({
				categoryInfo: url.prefetchedCategory,
				structuredData: url.prefetchedCategoryStructuredData ?? {},
			});
		}
	}, [url?.prefetchedCategory, url?.prefetchedCategoryStructuredData]);

	useEffect(() => {
		if (url?.prefetchedStaticPage?.content_id) {
			// No dedicated store; rely on passing data down
		}
	}, [url?.prefetchedStaticPage]);

	if (!url || typeof url.content_id === "undefined") return null;

	switch (url.content_type) {
		case "product":
			return <ProductPage id={url.content_id ?? 0} initialInfo={url.prefetchedProduct} />;
		case "category":
			return (
				<Category
					id={url.content_id ?? 0}
					initialCategory={url.prefetchedCategory}
					initialStructuredData={url.prefetchedCategoryStructuredData}
					prefetchedProducts={url.prefetchedProducts}
					prefetchedAvailableTags={url.prefetchedAvailableTags}
				/>
			);
		case "static_page":
			return <Static id={url.content_id ?? 0} initialPage={url.prefetchedStaticPage} />;
		case "404":
		default:
			return <Error404 params={url.params} />;
	}
};

export default UrlHandler;
